
import { Component, Prop, Vue } from "vue-property-decorator";
import WidgetTemplate from "@/components/Widgets/Templates/WidgetTemplate.vue";
import Image from "@/assets/images/people/people-1.png";
import { SMUser } from "@/store";
import { EMPLOYER_ROLE } from "@/constants/roles";

const MESSAGES = {
  // title: "Candidate\u00A0Assessment",
  title: "Candidate\u00A0eligibility\u00A0check",
};

@Component({
  components: {
    WidgetTemplate,
  },
})
export default class CompleteEmployerWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;

  MESSAGES = MESSAGES;

  image = Image;

  get list() {
    if (SMUser.user?.role === EMPLOYER_ROLE) {
      return this.$t("list.employer", { returnObjects: true });
    }

    return this.$t("list.candidate", { returnObjects: true });
  }
}
